import styled, { css } from 'styled-components';
import { rgba } from 'polished';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.colors.neutralSilver5};
    overflow-x: hidden;
    overflow-y: hidden;
    box-sizing: border-box;
    border-radius: 8px;
    padding: 0;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: end;
    border: 1px solid ${theme.colors.neutralSilver10};

    ::-webkit-scrollbar {
      width: 4px;
    }

    ::-webkit-scrollbar-thumb {
      background-color: ${theme.colors.neutralDark50};
      border-radius: 8px;

      &:hover {
        background-color: ${theme.colors.neutralDark50};
        border-radius: 8px;
      }
    }
  `}
`;

export const Content = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 600px;

    iframe {
      border: none;

      height: 100%;
      width: 100%;

      h3 {
        color: ${theme.colors.purple100};
        font-size: 1.6rem;
      }

      p {
        color: ${theme.colors.neutralDark50};
        font-size: 1.6rem;
        line-height: 24px;

        &:not(:last-child) {
          margin-bottom: 24px;
        }
      }
    }
  `}
`;

export const ScrollTop = styled.div`
  ${({ theme }) => css`
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: 48px;
    right: 18px;
    background-color: ${theme.colors.neutralSilver70};
    height: 100%;
    min-height: 44px;
    max-height: 44px;
    width: 44px;
    border-radius: 100%;
    color: ${theme.colors.globalWhite100};
    cursor: pointer;
    box-shadow: 0px 4px 4px ${rgba(theme.colors.shadowStatusHover, 0.08)},
      0px 4px 8px ${rgba(theme.colors.shadowStatusHover, 0.06)};
  `}
`;
